<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="data"
          sort-by="calories"
          class="elevation-1"
          :items-per-page="-1"
          hide-default-footer
          height="770"
          fixed-header
        >
          <template #top>
            <v-toolbar flat>
              <v-toolbar-title>Einkaufsartikel</v-toolbar-title>
              <v-divider class="mx-4" inset vertical />
              <v-spacer />
              <v-dialog v-model="dialog" max-width="800px">
                <template #activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    dark
                    class="mb-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    VERKAUFSARTIKEL HINZUFÜGEN
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container fluid>
                      <v-row>
                        <v-col cols="6">
                          <v-text-field
                            v-model="itemForm.name"
                            :error-messages="itemForm.errors.name"
                            label="Title"
                          />
                        </v-col>
                        <v-col cols="6">
                          <v-select
                            v-model="itemForm.supplier"
                            :items="supplier"
                            label="Hersteller"
                            :error-messages="itemForm.errors.supplier"
                          />
                        </v-col>
                        <v-col cols="6">
                          <v-checkbox
                            v-model="itemForm.rental"
                            label="Monatlicher Einkaufspreis"
                          />
                        </v-col>
                        <v-col cols="6">
                          <MoneyInputField
                            v-model="itemForm.price_purchasing"
                            :suffix="!itemForm.rental ? '€/stk' : '€/mon'"
                            label="Einkaufspreis"
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer />
                    <v-btn color="blue darken-1" text @click="close">
                      Cancel
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      :loading="itemForm.processing"
                      @click="save"
                    >
                      Save
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="deleteDialog" max-width="500px">
                <v-card>
                  <v-card-title class="headline">
                    Are you sure you want to delete this item?
                  </v-card-title>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn color="blue darken-1" text @click="closeDelete">
                      Cancel
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      :loading="itemForm.processing"
                      @click="deleteItemConfirm"
                    >
                      OK
                    </v-btn>
                    <v-spacer />
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template #[`header.name`]="{ header }">
            <v-menu
              v-if="columnValueList('name').length > 1"
              bottom
              right
              offset-y
              :close-on-content-click="false"
            >
              <template #activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon v-if="tableFilters.name.length > 0">
                    mdi-filter
                  </v-icon>
                  <v-icon v-else>
                    mdi-filter-outline
                  </v-icon>
                </v-btn>
              </template>
              <v-container fluid class="white">
                <v-checkbox
                  v-for="(check, key) in columnValueList('name')"
                  :key="'name_' + key"
                  v-model="tableFilters.name"
                  dense
                  hide-details
                  :label="check"
                  :value="check"
                />
              </v-container>
            </v-menu>
            {{ header.text }}
          </template>
          <template #[`header.supplier`]="{ header }">
            <v-menu
              v-if="columnValueList('supplier').length > 1"
              bottom
              right
              offset-y
              :close-on-content-click="false"
            >
              <template #activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon v-if="tableFilters.supplier.length > 0">
                    mdi-filter
                  </v-icon>
                  <v-icon v-else>
                    mdi-filter-outline
                  </v-icon>
                </v-btn>
              </template>
              <v-container fluid class="white">
                <v-checkbox
                  v-for="(check, key) in columnValueList('supplier')"
                  :key="'supplier_' + key"
                  v-model="tableFilters.supplier"
                  dense
                  hide-details
                  :label="check"
                  :value="check"
                />
              </v-container>
            </v-menu>
            {{ header.text }}
          </template>

          <template #[`item.price_purchasing`]="{ item }">
            <MoneyInputField
              v-model="item.price_purchasing"
              :suffix="!item.rental ? '€/stk' : '€/mon'"
              style="width: 140px"
              label="Einkaufspreis"
              @input="calculateMonthlyPrice(item)"
            />
          </template>
          <template #[`item.multiplier.term_36`]="{ item }">
            <MoneyInputField
              v-model="item.multiplier.term_36"
              :error-messages="itemForm.errors.multiplier"
              suffix="%"
              style="width: 140px"
              label="Marge"
              @input="calculateMonthlyPrice(item)"
            />
          </template>
          <template #[`item.multiplier.term_60`]="{ item }">
            <MoneyInputField
              v-model="item.multiplier.term_60"
              :error-messages="itemForm.errors.multiplier"
              suffix="%"
              style="width: 140px"
              label="Marge"
              @input="calculateMonthlyPrice(item)"
            />
          </template>
          <template #[`item.calculated.term_60`]="{ item }">
            <template v-if="!item.rental">
              ({{ item.price_purchasing ? item.price_purchasing : 0 }}€/stk +
              {{ item.multiplier.term_60 ? item.multiplier.term_60 : 0 }}%) / 60
              mon =
              {{
                new Intl.NumberFormat("de-DE", {
                  style: "currency",
                  currency: "EUR",
                }).format(
                  ((item.price_purchasing ? item.price_purchasing : 0) *
                    (1 +
                      (item.multiplier.term_60 ? item.multiplier.term_60 : 0) /
                      100.0)) /
                    60
                )
              }}/mon
            </template>
            <template v-else>
              ({{ item.price_purchasing ? item.price_purchasing : 0 }}€/mon +
              {{ item.multiplier.term_60 ? item.multiplier.term_60 : 0 }}%) =
              {{
                new Intl.NumberFormat("de-DE", {
                  style: "currency",
                  currency: "EUR",
                }).format(
                  (item.price_purchasing ? item.price_purchasing : 0) *
                    (1 +
                      (item.multiplier.term_60 ? item.multiplier.term_60 : 0) /
                      100.0)
                )
              }}/mon
            </template>
          </template>
          <template #[`item.calculated.term_36`]="{ item }">
            <template v-if="!item.rental">
              ({{ item.price_purchasing ? item.price_purchasing : 0 }}€/stk +
              {{ item.multiplier.term_36 ? item.multiplier.term_36 : 0 }}%) / 36
              mon =
              {{
                new Intl.NumberFormat("de-DE", {
                  style: "currency",
                  currency: "EUR",
                }).format(
                  ((item.price_purchasing ? item.price_purchasing : 0) *
                    (1 +
                      (item.multiplier.term_36 ? item.multiplier.term_36 : 0) /
                      100.0)) /
                    36
                )
              }}/mon
            </template>
            <template v-else>
              ({{ item.price_purchasing ? item.price_purchasing : 0 }}€/mon +
              {{ item.multiplier.term_36 ? item.multiplier.term_36 : 0 }}%) =
              {{
                new Intl.NumberFormat("de-DE", {
                  style: "currency",
                  currency: "EUR",
                }).format(
                  (item.price_purchasing ? item.price_purchasing : 0) *
                    (1 +
                      (item.multiplier.term_36 ? item.multiplier.term_36 : 0) /
                      100.0)
                )
              }}/mon
            </template>
          </template>
          <template #[`item.price.term_36`]="{ item }">
            <MoneyInputField
              v-model="item.price.term_36"
              :error-messages="itemForm.errors.price_buy"
              suffix="€/mon"
              style="width: 140px"
              label="Verkaufspreis"
            />
          </template>
          <template #[`item.price.term_60`]="{ item }">
            <MoneyInputField
              v-model="item.price.term_60"
              :error-messages="itemForm.errors.price_buy"
              suffix="€/mon"
              style="width: 140px"
              label="Verkaufspreis"
            />
          </template>
          <template #[`item.actions`]="{ item }">
            <v-icon small @click="deleteItem(item)">
              mdi-delete
            </v-icon>
          </template>
          <template #no-data>
            Keine Artikel gefunden.
          </template>
          <template #footer>
            <div class="text-end pa-2">
              <v-btn color="primary" @click="saveTable">
                save
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Admin'
import MoneyInputField from '@shared/MoneyInputField'

export default {
   metaInfo () {
      // don't know your return object structure,
      // maybe you should check whole this.getViewPage
      return {
         title: this.title ? this.title : 'Einkaufsartikel Übersicht',
      }
   },
   components: {
      MoneyInputField
   },
   layout: (h, page) => h(Layout, [page]),
   props: {
      data: {
         type: Array,
         required: true,
      },
      terms: {
         type: Array,
         required: true,
      },
   },
   data () {
      return {
         dialog: false,
         deleteDialog: false,
         headers: [
            { text: '#', value: 'id' },
            {
               text: 'Name',
               value: 'name',
               filter: (value) => {
                  if (this.tableFilters.name.length === 0) return true

                  return this.tableFilters.name.includes(value)
               },
            },
            {
               text: 'Lieferant',
               value: 'supplier',
               filter: (value) => {
                  if (this.tableFilters.supplier.length === 0) return true

                  return this.tableFilters.supplier.includes(value)
               },
            },
            { text: 'Einkaufspreis', value: 'price_purchasing' },
            { text: 'Marge 60mon', value: 'multiplier.term_60' },
            {
               text: 'berechneter Preis 60mon',
               value: 'calculated.term_60',
               sortable: false,
            },
            { text: 'Verkaufspreis 60mon', value: 'price.term_60' },
            { text: 'Marge 36mon', value: 'multiplier.term_36' },
            {
               text: 'berechneter Preis 36mon',
               value: 'calculated.term_36',
               sortable: false,
            },
            { text: 'Verkaufspreis 36mon', value: 'price.term_36' },
            { text: 'Aktionen', value: 'actions', sortable: false },
         ],
         tableFilters: {
            term: [],
            supplier: [],
            name: [],
         },
         supplier: ['LANCOM - HW', 'LANCOM - SW', 'DELL', 'Telekom', 'NWT'],
         editedIndex: -1,
         itemForm: this.$inertia.form({
            name: null,
            supplier: null,
            rental: false,
            price_purchasing: null,
         }),
         numberRules: [
            (v) =>
               !!v ||
          /^(\d+([,|.]?(?<=[,|.])\d{2})?)?$/.test(v) ||
          'Falsches Format',
         ],
      }
   },
   computed: {
      formTitle () {
         return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      },
   },
   watch: {
      dialog (val) {
         val || this.close()
      },
      deleteDialog (val) {
         val || this.closeDelete()
      },
      'itemForm.recentlySuccessful' (val) {
         if (val) {
            this.close()
            this.closeDelete()
            this.reset()
         }
      },
   },
   methods: {
      calculateMonthlyPrice (item) {
         let calc = 0
         if (!item.rental) {
            calc =
          ((item.price_purchasing ? item.price_purchasing : 0) *
            (1 +
              (item.multiplier.term_36 ? item.multiplier.term_36 : 0) /
                100.0)) /
          36
            item.price.term_36 =
          item.price.term_36 < Math.round(calc * 100) / 100
             ? Math.round(calc * 100) / 100
             : item.price.term_36
            calc =
          ((item.price_purchasing ? item.price_purchasing : 0) *
            (1 +
              (item.multiplier.term_60 ? item.multiplier.term_60 : 0) /
                100.0)) /
          60
            item.price.term_60 =
          item.price.term_60 < Math.round(calc * 100) / 100
             ? Math.round(calc * 100) / 100
             : item.price.term_60
         } else {
            calc =
          (item.price_purchasing ? item.price_purchasing : 0) *
          (1 + (item.multiplier.term_36 ? item.multiplier.term_36 : 0) / 100.0)
            item.price.term_36 =
          item.price.term_36 < Math.round(calc * 100) / 100
             ? Math.round(calc * 100) / 100
             : item.price.term_36
            calc =
          (item.price_purchasing ? item.price_purchasing : 0) *
          (1 + (item.multiplier.term_60 ? item.multiplier.term_60 : 0) / 100.0)
            item.price.term_60 =
          item.price.term_60 < Math.round(calc * 100) / 100
             ? Math.round(calc * 100) / 100
             : item.price.term_60
         }
      },
      columnValueList (val) {
         const list = this.data
            .map((offer) => offer[val])
            .filter(
               (value, index, self) => self.indexOf(value) === index && value !== ''
            )
         return list
      },

      deleteItem (item) {
         this.editedIndex = item.id

         this.deleteDialog = true
      },

      deleteItemConfirm () {
         this.$inertia.delete(
            this.route('purchase_item.soft_destroy', this.editedIndex)
         )
         this.closeDelete()
      },

      close () {
         this.dialog = false
         this.$nextTick(() => {
            this.reset()
            this.editedIndex = -1
         })
      },

      closeDelete () {
         this.deleteDialog = false
         this.$nextTick(() => {
            this.reset()
            this.editedIndex = -1
         })
      },

      reset () {
         this.itemForm.name = null
         this.itemForm.supplier = null
         this.itemForm.rental = false
         this.itemForm.clearErrors()
      },

      save () {
         this.itemForm.post(this.route('purchase_item.store'))
      },
      saveTable () {
         this.$inertia.put(this.route('purchase_item.updateTable'), {
            table: this.data,
         })
      },
   },
}
</script>
